import { ThemeOptions } from '@mui/material/styles';

export const themeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: '#12201f',
    },
    secondary: {
      main: '#ad5d4e',
      
    },
    
    
    divider: '#1b2021',
    background: {
      paper: '#c2ac8a',
      default: '#efe7d3',
    },
  },
  breakpoints: {
    // Add your custom breakpoints here
    values: {
      xs: 0,       // Mobile phones
      sm: 600,     // Tablets
      md: 960,     // Small laptops
      lg: 1280,    // Medium laptops
      xl: 1920,    // Large laptops and desktops
    },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // matches the footer so short pages / any residual overscroll
        // don't reveal a mismatched color below it
        body: {
          backgroundColor: '#12201f',
        },
      },
    },
  },

  typography: {
    fontFamily: 'Bree Serif',
    h1: {
      fontFamily: 'Anton, sans-serif',
      textTransform: 'uppercase',
      lineHeight: 0.95,
      fontSize: '2.75rem',
      '@media (min-width:600px)': {
        fontSize: '4rem', // Font size for tablets and larger
      },
      '@media (min-width:960px)': {
        fontSize: '5.5rem', // Font size for small laptops and larger
      },
      '@media (min-width:1280px)': {
        fontSize: '6.5rem', // Font size for medium laptops and larger
      },
    },
    h2: {
      fontFamily: 'Anton, sans-serif',
      textTransform: 'uppercase',
      lineHeight: 1,
      fontSize: '2rem',
      '@media (min-width:600px)': {
        fontSize: '3rem', // Font size for tablets and larger
      },
      '@media (min-width:960px)': {
        fontSize: '3.5rem', // Font size for small laptops and larger
      },
      '@media (min-width:1280px)': {
        fontSize: '4.5rem', // Font size for medium laptops and larger
      },

    },
    h3: {
        fontFamily: 'Anton, sans-serif',
        textTransform: 'uppercase',
        fontSize: '1.4rem',   // Default font size for all devices
        '@media (min-width:600px)': {
          fontSize: '1.3rem', // Font size for tablets and larger
        },
        '@media (min-width:960px)': {
          fontSize: '2.8rem', // Font size for small laptops and larger
        },
        '@media (min-width:1280px)': {
          fontSize: '3rem', // Font size for medium laptops and larger
        },
    },
    h6: {
      fontFamily: 'Anton, sans-serif',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      fontSize: '1.1rem',   // Default font size for all devices
      '@media (min-width:600px)': {
        fontSize: '1.3rem', // Font size for tablets and larger
      },
      '@media (min-width:960px)': {
        fontSize: '1.5rem', // Font size for small laptops and larger
      },
      '@media (min-width:1280px)': {
        fontSize: '2rem', // Font size for medium laptops and larger
      },
  },

    body1: {
      fontSize: '0.95rem',
        '@media (min-width:600px)': {
          fontSize: '1rem',   // Extra-small devices (phones)

        },
        '@media (min-width:960px)' : {
          fontSize: '1rem',   // Medium devices (desktops)
        },
        '@media (min-width:1280px)' : {
          fontSize: '1rem',   // Large devices (large desktops)

        }

    },

    body2: {
        fontSize: '0.95rem',
        '@media (min-width:600px)': {
          fontSize: '1rem',   // Extra-small devices (phones)

        },
        '@media (min-width:960px)' : {
          fontSize: '1rem',   // Medium devices (desktops)
        },
        '@media (min-width:1280px)' : {
          fontSize: '1rem',   // Large devices (large desktops)

        }
      }
  }
  
  
  
};
